import { OnboardingRequirementDto } from "../../../models/onboarding-requirement";

export class CarrierRequirementDialogParams{
    public carrierMasterApprovalRequirementId?: string;
    public carrierName: string;
    public carrierId: string;

}